module.exports = __webpack_public_path__ + "img/descImg4.f5f6c123.png";